import type { LeDataContentBlock } from '~/types/leData';

import { normalizeTableBlock } from '~/utils/leData/tableBlock';

export type ChatResultForPin = { columns: Array<string>; rows: Array<Record<string, unknown>> };

export function resolveChatResultForPin(blocks: Array<LeDataContentBlock>): ChatResultForPin | undefined {
  const sqlBlocks = blocks.filter((block) => block.type === 'sql');
  if (sqlBlocks.length !== 1) {
    return undefined;
  }

  const tablesWithRows = blocks.filter(
    (block) => block.type === 'table' && normalizeTableBlock(block.payload).dataRows.length > 0,
  );
  if (tablesWithRows.length !== 1) {
    return undefined;
  }

  const table = normalizeTableBlock(tablesWithRows[0].payload);
  const columns = table.headers.length ? table.headers : Object.keys(table.dataRows[0] ?? {});
  return { columns, rows: table.dataRows };
}
